import M from 'backbone.marionette'
import T from './grilleprogramme.html'
import { Loading } from '../../utils/bootstrap/loading';
import { ProgrammeListeView } from './programmeliste';


const filtreurs = new Backbone.Collection([
    {id: 'AS', filtre: 'AS'},
    {id: 'EQ', filtre: 'EQ'},
    {id: 'EV', filtre: 'EV'},
    {id: 'FP', filtre: 'FP'},
    {id: 'EV-FP', filtre: ['EV', 'FP', 'EV-FP']},
    {id: 'FC', filtre: 'FC'},
    {id: 'RÉUSSI', filtre: 'RÉUSSI'},
    {id: 'SU', filtre: 'SU'},
    {id: 'OA', filtre: 'OA'},
]);

const FiltreurDeStatut = M.View.extend({
    template: _.template(T),
    childViewTriggers: {
        'order:by':'order:by',
        'show:competence:statut':'show:competence:statut',
    },
    regions: {
        'liste':'.liste',
    },
    onRender: function(){
        this.showChildView('liste', new ProgrammeListeView({
            collection: this.getOption('results'),
            model: this.model,
        }))
    }
})

export const GrilleProgramme = M.View.extend({

    template: _.template('<div></div>'),
    regions: {
        'content':{
            el: '>div',
            replaceElement: true
        }
    },
    programmes: null,
    results: null,
    childViewTriggers: {
        'show:competence:statut':'show:competence:statut',
    },
    modelEvents: {
        'change:loading':'render',
        'change:loaded':'render',
    },

    initialize: function(){

        this.model = new Backbone.Model({
            loading: false,
            loaded: false,
            NoProgramme: this.getOption('noProgramme'),
        });
        this.results = new Backbone.Collection();
        this.loadData();
    },

    loadData: function(){
        if(!this.model.get('NoProgramme'))return;
        this.model.set({
            loading: true,
            loaded: false
        })
        $.ajax({
            url: 'api/filtreurdestatut/programme',
            cache: false,
            data: {
                NoProgramme: this.model.get('NoProgramme')
            },
            success: (response) => {
                this.results.reset(response.results)
                this.model.set({
                    loading: false,
                    loaded: true
                })
            },
            error: (xhr) => {

            }
        })
    },
    onRender: function(){
        if(this.model.get('loading')){
            this.showChildView('content', new Loading())
        }else{
            this.showChildView('content', new FiltreurDeStatut({
                model: this.model,
                results: this.results
            }))
        }
    },
    onShowCompetenceStatut: function(view){
        // un statut a été sélectionné. Charger les infos en lien avec la compétence et le statut sélectionné
        // finalement, on y va avec un direct link (pour permettre d'Accéder à cet interface à partir de
        // n'importe quel endroit dans la plateforme...)
    }
})